import { render, staticRenderFns } from "./addFreeze.vue?vue&type=template&id=1cd86dfd&scoped=true&"
import script from "./addFreeze.vue?vue&type=script&lang=js&"
export * from "./addFreeze.vue?vue&type=script&lang=js&"
import style0 from "./addFreeze.vue?vue&type=style&index=0&id=1cd86dfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd86dfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd86dfd')) {
      api.createRecord('1cd86dfd', component.options)
    } else {
      api.reload('1cd86dfd', component.options)
    }
    module.hot.accept("./addFreeze.vue?vue&type=template&id=1cd86dfd&scoped=true&", function () {
      api.rerender('1cd86dfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/userControl/components/addFreeze.vue"
export default component.exports